module.exports = __webpack_public_path__ + "selfie_harrypotter.a6efcfc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/components/routes/ItemView/images/selfie_harrypotter.jpg
// module id = MvCC
// module chunks = 0